// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PushkinIconForCard_wrapper__22B-b","iconBg":"PushkinIconForCard_iconBg__3WS4_"};